import { NotificationNavBridge } from "@/components/NotificationNavBridge";
import PublicAsk from "@/pages/ask/PublicAsk";
import PublicThanks from "@/pages/ask/PublicThanks";
import AskCreate from "@/pages/ask/AskCreate";
import AskDetail from "@/pages/ask/AskDetail";
import AskHome from "@/pages/ask/AskHome";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import Onboarding from "@/pages/Onboarding";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import NameSetup from "@/pages/NameSetup";
import Activation from "@/pages/Activation";
import Home from "@/pages/Home";
import AddDebt from "@/pages/AddDebt";
import DebtSuccess from "@/pages/DebtSuccess";
import DebtDetails from "@/pages/DebtDetails";
import People from "@/pages/People";
import PersonHistory from "@/pages/PersonHistory";
import HistoryPage from "@/pages/History";
import Notifications from "@/pages/Notifications";
import Profile from "@/pages/Profile";
import Upgrade from "@/pages/Upgrade";
import PaymentCallback from "@/pages/PaymentCallback";
import PublicAck from "@/pages/PublicAck";
import PublicRepayment from "@/pages/PublicRepayment";
import VerifyEmail from "@/pages/VerifyEmail";
import BrandKit from "@/pages/BrandKit";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import DeleteAccount from "@/pages/DeleteAccount";
import AdminPortal from "@/pages/admin/AdminPortal";
import RepaymentAccount from "@/pages/settings/RepaymentAccount";
import PublicBankRepayment from "@/pages/PublicBankRepayment";
import PublicDebtView from "@/pages/PublicDebtView";
import AccountSettings from "@/pages/settings/AccountSettings";
import SecuritySettings from "@/pages/settings/SecuritySettings";
import NotificationSettings from "@/pages/settings/NotificationSettings";
import PrivacySettings from "@/pages/settings/PrivacySettings";
import HelpSettings from "@/pages/settings/HelpSettings";

function App() {
  return (
    <div className="App">
      <div className="ambient-bg" />
      <BrowserRouter>
        <AuthProvider>
          <NotificationNavBridge />
          <Routes>
            {/* Public */}
            <Route path="/welcome" element={<Onboarding />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/brandkit" element={<BrandKit />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/admin" element={<AdminPortal />} />
            <Route path="/br/:token" element={<PublicBankRepayment />} />
            <Route path="/d/:token" element={<PublicDebtView />} />
            <Route path="/a/:token" element={<PublicAck />} />
            <Route path="/r/:token" element={<PublicRepayment />} />
            <Route path="/ask/:token" element={<PublicAsk />} />
            <Route path="/t/:token" element={<PublicThanks />} />
            <Route path="/asks/new" element={<ProtectedRoute><AskCreate /></ProtectedRoute>} />
            <Route path="/asks/:id" element={<ProtectedRoute><AskDetail /></ProtectedRoute>} />

            {/* Auth'd — full screen (no shell) */}
            <Route path="/setup-name" element={<ProtectedRoute><NameSetup /></ProtectedRoute>} />
            <Route path="/activate" element={<ProtectedRoute><Activation /></ProtectedRoute>} />
            <Route path="/add" element={<ProtectedRoute><AddDebt /></ProtectedRoute>} />
            <Route path="/add/success/:id" element={<ProtectedRoute><DebtSuccess /></ProtectedRoute>} />
            <Route path="/debt/:id" element={<ProtectedRoute><DebtDetails /></ProtectedRoute>} />
            <Route path="/upgrade" element={<ProtectedRoute><Upgrade /></ProtectedRoute>} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/settings/account" element={<ProtectedRoute><AccountSettings /></ProtectedRoute>} />
            <Route path="/settings/security" element={<ProtectedRoute><SecuritySettings /></ProtectedRoute>} />
            <Route path="/settings/notifications" element={<ProtectedRoute><NotificationSettings /></ProtectedRoute>} />
            <Route path="/settings/repayment" element={<ProtectedRoute><RepaymentAccount /></ProtectedRoute>} />
            <Route path="/settings/privacy" element={<ProtectedRoute><PrivacySettings /></ProtectedRoute>} />
            <Route path="/settings/help" element={<ProtectedRoute><HelpSettings /></ProtectedRoute>} />

            {/* Auth'd — with bottom nav shell */}
            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/" element={<Home />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/people" element={<People />} />
              <Route path="/asks" element={<AskHome />} />
              <Route path="/people/:id" element={<PersonHistory />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
